import Card from "components/Card/Card";
import { ReactComponent as PackageIcon } from "../../../../assets/benefits/package-icon.svg";
import { ReactComponent as FreeTimeIcon } from "../../../../assets/benefits/free-time-icon.svg";
import { ReactComponent as CashIcon } from "../../../../assets/benefits/cash-icon.svg";
import { ReactComponent as SupportIcon } from "../../../../assets/benefits/support-icon.svg";
import { useTranslation } from "react-i18next";
import { CardPropsType } from "components/Card/types";
import "./i18n";
import "./benefits.scss";
import Title from "components/Title/Title";
import Reveal from "components/Reveal/Reveal";

const Benefits = () => {
  const { t } = useTranslation();

  const Cards: CardPropsType[] = [
    {
      title: t("benefits:packageCardTitle"),
      message: t("benefits:packageCardText"),
      icon: <PackageIcon />,
    },
    {
      title: t("benefits:freeTimeCardTitle"),
      message: t("benefits:freeTimeCardText"),
      icon: <FreeTimeIcon />,
    },
    {
      title: t("benefits:cashCardTitle"),
      message: t("benefits:cashCardText"),
      icon: <CashIcon />,
    },
    {
      title: t("benefits:supportCardTitle"),
      message: t("benefits:supportCardText"),
      icon: <SupportIcon />,
    },
  ];

  return (
    <div className="benefits-container">
      <div className="benefits-container-row title-container">
        <Title title={t("benefits:title")} color="light-blue" />
      </div>
      <div className="benefits-container-row cards-container">
        {Cards.map((card, index) => (
          <div
            key={index}
            className="benefits-container-col-md-1 benefits-container-col-sm-2 benefits-container-col-xs-4 benefits-container-col"
          >
            {window.innerWidth < 667 ? (
              <Reveal revealType="horizontal" delay={100 * index}>
                <Card {...card}></Card>
              </Reveal>
            ) : (
              <Card {...card}></Card>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
